import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import './VerifyMakeUpSessionSchedulePage.css';
import GetMakeActions from '../../../redux/GetMakeRedux';
import ApplyMakeActions from '../../../redux/ApplyMakeRedux';
import { ArrowLeft } from '../../../assets/icons';
import moment from 'moment';
import AlertBox from '../../../components/AlertBox';

// Interface for props
interface VerifyMakeUpSessionSchedulePageProps {
  t?: any;
  // Navigation props - from wrapper
  categoryId?: string;
  childId?: string;
  code?: string;
  make_id?: string;
  timeslotId?: string;
  onNavigate?: (route: string, params?: any) => void;
  onGoBack?: () => void;
  // Redux props - Phase 2: Redux Integration
  getMakeFetching?: boolean;
  getMakeSuccess?: boolean;
  getMakeError?: boolean;
  dataMake?: any;
  applyMakeFetching?: boolean;
  applyMakeSuccess?: boolean;
  applyMakeError?: boolean;
  applyMakeStatus?: number;
  status?: any;
  // Redux actions - Phase 2: Redux Integration
  getMake?: (make_id: string) => void;
  applyMake?: (make_id: string, make?: any) => void;
}

interface VerifyMakeUpSessionSchedulePageState {
  isLoading: boolean;
  alertPopupOpen: boolean;
  alertMessage: string;
}

class VerifyMakeUpSessionSchedulePage extends Component<VerifyMakeUpSessionSchedulePageProps, VerifyMakeUpSessionSchedulePageState> {
  constructor(props: VerifyMakeUpSessionSchedulePageProps) {
    super(props);
    
    // Phase 3: URL parameters - Navigation & URL Parameters
    if (this.props.getMake && this.props.make_id) {
      this.props.getMake(this.props.make_id);
    }
    
    this.state = {
      isLoading: false,
      alertPopupOpen: false,
      alertMessage: '',
    };
  }

  componentDidMount() {
    console.log('VerifyMakeUpSessionSchedulePage mounted');
    
    // Phase 2: Redux integration - Redux Integration
    if (this.props.getMake && this.props.make_id) {
      this.props.getMake(this.props.make_id);
    }
  }

  // Phase 2: Redux integration - Redux Integration
  UNSAFE_componentWillReceiveProps(nextProps: VerifyMakeUpSessionSchedulePageProps) {
    console.log('UNSAFE_componentWillReceiveProps - nextProps.applyMakeSuccess:', nextProps.applyMakeSuccess);
    console.log('UNSAFE_componentWillReceiveProps - this.props.applyMakeSuccess:', this.props.applyMakeSuccess);
    
    if (
      nextProps.applyMakeSuccess !== this.props.applyMakeSuccess &&
      nextProps.applyMakeSuccess === true
    ) {
      console.log('applyMakeSuccess changed to true, calling applyLeaveSuccess');
      this.applyLeaveSuccess();
    }
  }

  // Phase 5: User interactions - will be uncommented in phase 5
  applyLeaveSuccess = () => {
    setTimeout(() => {
      this._message();
    }, 500);
  };

  // Phase 6: Alert & Error Handling - Enhanced message handling
  _message = () => {
    const { t, status, onNavigate } = this.props;

    console.log('status', status);
    
    if (status?.success === false) {
      if (status?.message && status.message !== " ") {
        // Show specific error alert
        /* this.showAlert(
            t?.('common:error') || 'Error',
            status.message,
            'error'
          );
        );
         */
        this.setState({ alertPopupOpen: true, alertMessage: status.message });
      } else {
        // Show generic error alert
        /* this.showAlert(
          t?.('common:error') || 'Error',
          t?.('make-up-session:apply-failed') || 'Failed to apply make-up session. Please try again.',
          'error'
        ); */
        this.setState({ alertPopupOpen: true, alertMessage: t?.('make-up-session:apply-failed') || 'Failed to apply make-up session. Please try again.' });
      }
      // Navigate back to calendar after error
      /* setTimeout(() => {
        if (onNavigate) {
          onNavigate('calendar');
        }
      }, 2000); */
    } else if (status?.success === true) {

      this.setState({ alertPopupOpen: true, alertMessage: t?.('make-up-session:apply-success') || 'Request submited' });
      // Show success alert
      // this.showAlert(
      //   t?.('common:success') || 'Success',
      //   t?.('make-up-session:apply-success') || 'Make-up session applied successfully!',
      //   'success'
      // );
      // Navigate back to calendar after success
      /* setTimeout(() => {
        if (onNavigate) {
          onNavigate('calendar');
        }
      }, 2000); */
    }
  };

  alertSuccessOk = () => {
    this.setState({ alertPopupOpen: false });
    if (this.props.onNavigate) {
      this.props.onNavigate('calendar');
    }
  };

  // Phase 6: Alert & Error Handling - Alert display method
  showAlert = (title: string, message: string, type: 'success' | 'error' | 'info') => {
    // Create alert element
    const alertDiv = document.createElement('div');
    alertDiv.className = `alert-overlay alert-${type}`;
    alertDiv.innerHTML = `
      <div class="alert-content">
        <div class="alert-icon">
          ${type === 'success' ? '✓' : type === 'error' ? '✗' : 'ℹ'}
        </div>
        <div class="alert-text">
          <h3 class="alert-title">${title}</h3>
          <p class="alert-message">${message}</p>
        </div>
        <button class="alert-close" onclick="this.parentElement.parentElement.remove()">×</button>
      </div>
    `;
    
    // Add to body
    document.body.appendChild(alertDiv);
    
    // Auto remove after 5 seconds
    setTimeout(() => {
      if (alertDiv.parentNode) {
        alertDiv.parentNode.removeChild(alertDiv);
      }
    }, 5000);
  };

  // Phase 5: User interactions - User Interactions
  applyLeavee = () => {
    if (this.props.applyMake && this.props.make_id) {
      const make = {
        is_reschedule: true,
      };
      if (this.props.code === "reschedule-a-make-up-session") {
        this.props.applyMake(this.props.make_id, make);
      } else {
        this.props.applyMake(this.props.make_id);
      }
    }
  };

  _onRefresh = () => {
    if (this.props.getMake && this.props.make_id) {
      this.props.getMake(this.props.make_id);
    }
  };

  // Phase 4: Data Display & Logic - Checkbox selection logic
  _onCheckBox = (item: any, id: string) => {
    console.log('Checkbox clicked:', item, id);
    // Additional checkbox logic can be added here if needed
  };

  render() {
    const { 
      t, 
      onGoBack, 
      getMakeFetching, 
      getMakeSuccess, 
      getMakeError, 
      dataMake,
      applyMakeFetching,
      applyMakeSuccess,
      applyMakeError
    } = this.props;
    const { isLoading } = this.state;

    // Phase 4: Data Display & Logic - Enhanced data handling
    const fullDataMake = this.props.dataMake || { data: [], name: '' };
    const sessionData = fullDataMake?.data || [];
    const hasSessions = sessionData && sessionData.length > 0;
    const isReschedule = this.props.code === "reschedule-a-make-up-session";
    
    // Debug logging
    console.log('VerifyMakeUpSessionSchedulePage render - dataMake (array):', dataMake);
    console.log('VerifyMakeUpSessionSchedulePage render - fullDataMake:', fullDataMake);
    console.log('VerifyMakeUpSessionSchedulePage render - sessionData:', sessionData);
    console.log('VerifyMakeUpSessionSchedulePage render - hasSessions:', hasSessions);
    console.log('VerifyMakeUpSessionSchedulePage render - getMakeSuccess:', getMakeSuccess);
    console.log('VerifyMakeUpSessionSchedulePage render - getMakeFetching:', getMakeFetching);
    console.log('VerifyMakeUpSessionSchedulePage render - getMakeError:', getMakeError);
    console.log('VerifyMakeUpSessionSchedulePage render - applyMakeFetching:', applyMakeFetching);
    console.log('VerifyMakeUpSessionSchedulePage render - applyMakeSuccess:', applyMakeSuccess);
    console.log('VerifyMakeUpSessionSchedulePage render - applyMakeError:', applyMakeError);

    return (
      <div className="verifymakeupsessionschedule-page">
        {/* Header */}
        <div className="page-header">
          <div className="page-header-inner">
            <div className="header-left">
              <button 
                className="header-button back-button"
                onClick={onGoBack}
              >
                <ArrowLeft />
              </button>
              <h1 className="header-title">
                {t?.('verify-request:verify-make') || 'Verify Make Up Session Schedule'}
              </h1>
            </div>
            <div className="header-right">
              {/* Empty for now */}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="page-content">
          {/* Description */}
          <div className="description-section">
            <p className="description-text">
              {t?.('make-up-session:make-up-session-details') || 'Make-up session details'}
            </p>
          </div>
          
          {/* Phase 4: Data Display & Logic - Enhanced conditional rendering */}
          {fullDataMake && fullDataMake.data && fullDataMake.data.length > 0 ? (
            <div className="session-list-container">
              {/* Loading Indicator - Phase 2 */}
              {getMakeFetching && (
                <div className="loading-container">
                  <div className="loading-spinner"></div>
                </div>
              )}

              {/* Error State - Phase 6 */}
              {getMakeError && !getMakeFetching && (
                <div className="error-container">
                  <div className="error-content">
                    <h3 className="error-title">
                      {t?.('common:error') || 'Error'}
                    </h3>
                    <p className="error-text">
                      {t?.('common:error-loading-data') || 'Failed to load session data. Please try again.'}
                    </p>
                    <button 
                      className="retry-button"
                      onClick={this._onRefresh}
                    >
                      {t?.('common:retry') || 'Retry'}
                    </button>
                  </div>
                </div>
              )}

              {/* Session List - Phase 4 */}
              {getMakeSuccess && !getMakeFetching && !getMakeError && (
                <div className="session-list">
                  {fullDataMake?.data?.map((item: any, index: number) => (
                  <div key={index} className="session-item">
                    {index > 0 && <div className='session-item-seperator' />}
                    <div className="session-content">
                      <div className="session-header">
                        <h3 className="session-title">
                          {item?.option_schedule === 1
                            ? t?.('select-leavere-quest:before') || 'Before'
                            : item?.option_schedule === 2
                            ? t?.('select-leavere-quest:after') || 'After'
                            : item?.option_schedule === 0
                            ? t?.('make-up-session:make-up-session') || 'Make-up Session'
                            : t?.('make-up-session:make-up-session') || 'Make-up Session'}
                        </h3>
                      </div>
                      
                      <div className="session-details">
                        <div className="detail-row">
                          <span className="detail-label">
                            {t?.('appointment-summary-screen:summary.item.name') || 'Name'}
                          </span>
                          <span className="detail-value">
                            {fullDataMake.name}
                          </span>
                        </div>
                        
                        <div className="detail-row">
                          <span className="detail-label">
                            {t?.('appointment-summary-screen:summary.item.date') || 'Date'}
                          </span>
                          <span className="detail-value">
                            {item?.date
                              ? moment(item?.date?.date).format("DD MMMM YYYY")
                              : ""}
                          </span>
                        </div>
                        
                        <div className="detail-row">
                          <span className="detail-label">
                            {t?.('appointment-summary-screen:summary.item.time') || 'Time'}
                          </span>
                          <span className="detail-value">
                            {item?.time ? item?.time : ""}
                          </span>
                        </div>
                        
                        <div className="detail-row">
                          <span className="detail-label">
                            {t?.('select-leavere-quest:therapist') || 'Therapist'}
                          </span>
                          <span className="detail-value">
                            {item?.therapist ? item?.therapist : ""}
                          </span>
                        </div>
                        
                        <div className="detail-row">
                          <span className="detail-label">
                            {t?.('select-leavere-quest:service-type') || 'Service Type'}
                          </span>
                          <span className="detail-value">
                            {item?.service_type ? item?.service_type : ""}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  ))}
                </div>
              )}

            </div>
          ) : (
            /* No Charge View - Phase 4 */
            <div className="no-charge-container">
              <div className="no-charge-content">
                <h3 className="no-charge-title">
                  {t?.('make-up-session:no-charge') || 'No Charge'}
                </h3>
                <p className="no-charge-text">
                  {t?.('make-up-session:by-submiting') || 'By submitting this form...'}
                </p>
              </div>
            </div>
          )}

          {/* Phase 5: User Interactions - Action Buttons */}
          <div className="action-buttons">
            <button 
              className={`comman-btn w-100 confirm-button ${applyMakeFetching ? 'loading' : ''}`}
              onClick={this.applyLeavee}
              disabled={applyMakeFetching}
            >
              {applyMakeFetching ? (
                <div className="button-loading">
                  <div className="button-spinner"></div>
                  <span>{t?.('common:processing') || 'Processing...'}</span>
                </div>
              ) : (
                t?.('common:confirm') || 'CONFIRM'
              )}
            </button>
            <button 
              className="cancel-button comman-btn w-100"
              onClick={() => onGoBack && onGoBack()}
              disabled={applyMakeFetching}
            >
              {t?.('common:cancel') || 'CANCEL'}
            </button>
          </div>
        </div>

        <AlertBox
          title={t?.('common:message') || 'Message'}
          message={this.state.alertMessage}
          isVisible={this.state.alertPopupOpen}
          onClose={() => {}}
          okAction={this.alertSuccessOk}
          okText={t?.('common:ok') || 'OK'}
        />

      </div>
    );
  }
}

// Phase 2: Redux connection - Redux Integration
const mapStateToProps = (state: any) => {
  console.log('state', state);
  return {
    getMakeFetching: state.getMake.fetching,
    getMakeSuccess: state.getMake.success,
    getMakeError: state.getMake.error,
    dataMake: state.getMake.dataMake,
    applyMakeFetching: state.applyMake.fetching,
    applyMakeSuccess: state.applyMake.success,
    applyMakeError: state.applyMake.error,
    applyMakeStatus: state.applyMake.status,
    status: state.applyMake.makedata,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getMake: (make_id: string) =>
      dispatch(GetMakeActions.getMakeRequest(make_id)),
    applyMake: (make_id: string, make?: any) =>
      dispatch(ApplyMakeActions.applyMakeRequest(make_id, make)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VerifyMakeUpSessionSchedulePage));